import React from 'react';
import style from './SmallLoader.module.scss';

const SmallLoader = () => <div className={style.loader + " small-loader"} />;

export default SmallLoader;
